import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'app-clear-btn',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearBtnComponent extends ButtonComponent {
  constructor() {
    super();
    this.icon = 'close';
    this.label = $localize`Wyczyść`;
    this.style = 'tertiary';
  }
}
